var React = require('react');

function ChevronLeftInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path 3"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Gallery-lightbox-(light)","transform":"translate(-11.000000, -584.000000)","fill":"#171717"},React.createElement("polygon",{"id":"Path-3","points":"12.4349365 595.278931 19.5651129 584.248177 18.3570557 584 11 595.116333 18.3570557 606.403198 19.5651129 606.227585"})))]);
}

ChevronLeftInline.defaultProps = {"width":"9px","height":"23px","viewBox":"0 0 9 23","version":"1.1"};

module.exports = ChevronLeftInline;

ChevronLeftInline.default = ChevronLeftInline;
